import { combineReducers } from "redux";

import appConfig from "./appConfig";
import introSlides from "./introSlides";
import themeColors from "./themeColors";
import token from "./token";

export default combineReducers({
  appConfig,
  introSlides,
  themeColors,
  token
});
